export const lightTheme = {
    toggleBorder: "#FFF",
    gradient: "linear-gradient(#39598A, #79D7ED)",

    background: "#eeeeee",
    textOnBackground: "#363537",

    primary: "#00adb5",
    textOnPrimary: "#e0fbfc",
    primaryVariant: "#3700B3",

    secondary: "#3d5a80",
    textOnSecondary: "#98c1d9",
    secondaryVariant: "#018786",

    surface: "#FFF",
    error: "#B00020",
    onPrimary: "#FFF",
    onSecondary: "#000",
    onBackground: "#000",
    onSurface: "#000",
    onError: "#FFF",
}

export const darkTheme = {
    toggleBorder: "#6B8096",
    gradient: "linear-gradient(#091236, #1E215D)",

    background: "#393e46",
    textOnBackground: "#c3b6a2",

    primary: "#222831",
    textOnPrimary: "#e0fbfc",
    primaryVariant: "#3700B3",

    secondary: "#393e46",
    secondaryVariant: "#03DAC6",
    surface: "#121212",
    error: "#CF6679",
    onPrimary: "#000",
    onSecondary: "#000",
    onBackground: "#FFF",
    onSurface: "#FFF",
    onError: "#000",
}
